import { createPortal } from 'react-dom';
var portalNode = document.getElementById('portalRoot');
export var Portal = function (_a) {
    var container = _a.container, key = _a.key, children = _a.children;
    return portalNode && createPortal(children, container || portalNode, key);
};
